export function setCookie({ cName, cValue, exTime }: { cName: string; cValue: string; exTime: string }) {
  let expires = 'expires=' + exTime;
  document.cookie = cName + '=' + cValue + ';' + expires + ';path=/';
}

export function getCookie({ cname }: { cname: string }) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
